import React from "react";
import "./index.less";

const EquipTypeTag = (props: {
  type: number;
  name: string;
  isDisabled?: boolean;
}) => {
  const { name, type, isDisabled = false } = props;
  if (!name) return null;
  const styleFromType = {
    4: "superFast",
    2: "fast",
    5: "slow",
  };
  if (isDisabled) {
    return (
      <div className="equipTypeTagWrapper">
        <div
          className={
            styleFromType?.[type]
              ? `${styleFromType[type]} disabled`
              : `slow disabled`
          }
        >
          <span className="typeText">{name}</span>
        </div>
      </div>
    );
  }
  return (
    <div className="equipTypeTagWrapper">
      <div className={styleFromType?.[type] ? styleFromType[type] : "slow"}>
        <span className="typeText">{name}</span>
      </div>
    </div>
  );
};

export default EquipTypeTag;
